import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client';
import { BATCH_STATUS_QUERY } from '~/modules/common/hooks/useBatchStatus';
import { CurrentProgressBarContent } from '~/modules/common/components';

const useStyles = makeStyles(theme => ({
  sectionTitle: {
    fontWeight: theme.typography.fontWeightMedium
  },
  infoMessage: {
    fontWeight: theme.typography.fontWeightMedium
  }
}));

export const ProgressContent = ({ batchId, itemCounts, onBatchComplete }) => {
  const classes = useStyles();

  const { data, stopPolling } = useQuery(BATCH_STATUS_QUERY, {
    variables: { batchId },
    fetchPolicy: 'network-only',
    pollInterval: 500,
    skip: !batchId
  });

  const batchStatus = data?.getBatchStatus || {};
  const { executionState, overallProgress } = batchStatus;

  const hasProcessed =
    executionState === 'SUCCEEDED' ||
    executionState === 'CANCELLED' ||
    executionState === 'FAILED';

  const progressInfo = useMemo(
    () => (
      <Typography className={classes.infoMessage} variant="caption">
        <FormattedMessage id="moveTimeDialog.cancelDoesNotUndo" />
      </Typography>
    ),
    [classes.infoMessage]
  );

  useEffect(() => {
    if (!hasProcessed) return;
    stopPolling();
    onBatchComplete();
  }, [hasProcessed, stopPolling, onBatchComplete]);

  return (
    <>
      <Typography variant="h6" className={classes.sectionTitle}>
        <FormattedMessage id="moveTimeDialog.movingTimeEntries" />
      </Typography>
      <CurrentProgressBarContent
        currentProgress={overallProgress?.currentProgress ?? 0}
        itemCounts={itemCounts}
        progressInfo={progressInfo}
      />
    </>
  );
};

ProgressContent.propTypes = {
  batchId: PropTypes.string,
  itemCounts: PropTypes.number.isRequired,
  onBatchComplete: PropTypes.func.isRequired
};

export default ProgressContent;
